<template>
  <div class="recommend-product" v-show="recommendProductList.length">
    <div class="header-wrap">
      <div class="title">{{ letter.v3RecommendedProducts }}</div>
    </div>
    <div
      class="recommend-product-wrap swiper-container recommend-product-swiper"
      id="recommendProduct"
      :key="lang"
    >
      <div class="swiper-wrapper product-list">
        <div
          class="swiper-slide recommend-product-item shadow"
          v-for="(item, index) in recommendProductList"
          :key="index"
          @click="showDetailPopup(item)"
        >
          <gift-icon
            :background="getRecommendGiftBanckground(item)"
            :gifts="getGiftIcons(item)"
          ></gift-icon>
          <product-info
            :productName="getProductName(item)"
            :productDetail="getProductDetail(item)"
            @selectProduct="selectProduct"
            @clickAddToCart="clickAddToCart"
            :price="item.GAME_AMOUNT"
            :item="item"
          ></product-info>
        </div>
      </div>
      <Icon
        class="recommend-product-pagination recommend-product-prev"
        name="right"
      />
      <Icon
        class="recommend-product-pagination recommend-product-next"
        name="right"
      />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { mapState } from 'vuex';
import product from '@mixins/officialTopup/product';
import productName from '@mixins/product';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import ProductInfo from '@components/officialTopup/product/ProductInfo.vue';
export default {
  name: 'RecommendProduct',
  mixins: [product, productName, cartAddAndDetail],
  data() {
    return {
      swiper: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      allProductList: state => state.productList,
      showCurrency: state => state.showCurrency,
      recommend: state => state.activity.recommend
    }),
    recommendIdList() {
      // recommend.basic?.priceId不为空的情况，合成一个新数组
      const list = [];
      this.recommend.forEach(item => {
        if (item?.basic?.priceId) {
          list.push(item.basic.priceId);
        }
      });
      return list;
    },
    recommendProductList() {
      // 遍历商品列表，返回匹配推荐id的商品，推荐id：`${item.PRODUCT_ID}${item.CP_PRODUCT_ID}`
      const list = [];
      this.recommendIdList.map(id => {
        const rItem = this.allProductList.find(
          item => id === `${item.PRODUCT_ID}${item.CP_PRODUCT_ID}`
        );
        if (rItem) {
          list.push(rItem);
        }
      });
      return list;
    }
  },
  watch: {
    recommendProductList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  methods: {
    selectProduct(item) {
      this.$emit('selectProduct', item);
    },
    clickAddToCart(item) {
      this.$emit('clickAddToCart', item);
    },
    showDetailPopup(item) {
      this.$emit('showDetailPopup', {
        ...item,
        showBtn: true
      });
      // todo 打点
      // clickButton({
      //   btnName: 'confirm_product',
      //   locationKey: locationType.selectProduct
      // });
    },
    initSwiper() {
      try {
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('#recommendProduct', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 40,
          navigation: {
            nextEl: '.recommend-product-next',
            prevEl: '.recommend-product-prev'
          }
        });
      } catch (err) {
        console.error(err);
      }
    }
  },

  components: {
    ProductInfo
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.recommend-product {
  width: 100%;
  cursor: pointer;

  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: unset;

    .header-title {
      font-size: 32px;
    }
  }
  .recommend-product-wrap {
    position: relative;
    display: flex;
    padding: 10px 15px 30px 15px;
    margin: -10px -15px;
    margin-right: -40px;
    align-items: center;
    overflow-x: hidden;
    overflow-y: auto;

    .product-list {
      display: flex;
      flex-wrap: nowrap;
    }

    .recommend-product-item {
      position: relative;
      flex-shrink: 0;
      width: 513px;
      background-color: #fff;
      border-radius: 20px;
    }
    .recommend-product-pagination {
      display: none;
    }
  }
}

@media screen and (orientation: landscape) {
  .recommend-product {
    margin-bottom: 10px;

    .header-wrap {
      .header-title {
        font-size: 28px;
      }

      .header-btn {
        font-size: 20px;

        .jump-icon {
          width: 26px;
          height: 26px;
        }
      }
    }
    .recommend-product-wrap {
      margin-right: -15px;
      .recommend-product-item {
        width: 540px;
      }
      .recommend-product-pagination {
        display: block;
        cursor: pointer;
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #ffffff;
        border: 1px solid #cccccc;
        z-index: 2;

        &.recommend-product-next {
          right: 0;
        }
        &.recommend-product-prev {
          rotate: 180deg;
          left: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';

.swiper-button-disabled {
  opacity: 0 !important;
}
</style>
